module.exports = __webpack_public_path__ + "static/media/spring.b213ea0b.png";